import { areRecordsEquals, type ReadonlyRecord } from '../../utils'

export type CybusConfiguredResources = ReadonlyRecord<
    'connections' | 'containers' | 'endpoints' | 'routes' | 'mappings' | 'roles' | 'servers' | 'nodes' | 'users' | 'volumes',
    number
>

export const areCybusConfiguredResourcesEquals: (a: CybusConfiguredResources, b: CybusConfiguredResources) => boolean = areRecordsEquals

export type CybusAvailableResources = ReadonlyRecord<'servers' | 'nodes' | 'containers' | 'volumes' | 'connections' | 'endpoints' | 'mappings', number>

export const areCybusAvailableResourcesEquals: (a: CybusAvailableResources, b: CybusAvailableResources) => boolean = areRecordsEquals
